import CustomLoaderPreview from './CustomLoaderPreview';
export default CustomLoaderPreview;